export const tableData = [
  {
    company: 'GSK',
    project: 'vaccine routine',
    gateway: 'data',
    label: 'data',
    catm1s: 'data',
  },
  {
    company: 'GSK',
    project: 'vaccine routine',
    gateway: 'data',
    label: 'data',
    catm1s: 'data',
  },
  {
    company: 'GSK',
    project: 'vaccine routine',
    gateway: 'data',
    label: 'data',
    catm1s: 'data',
  },
  {
    company: 'GSK',
    project: 'vaccine routine',
    gateway: 'data',
    label: 'data',
    catm1s: 'data',
  },
  {
    company: 'GSK',
    project: 'vaccine routine',
    gateway: 'data',
    label: 'data',
    catm1s: 'data',
  },
  {
    company: 'GSK',
    project: 'vaccine routine',
    gateway: 'data',
    label: 'data',
    catm1s: 'data',
  },
];

export const orgTableData = [
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
  {
    company: 'GSK',
    headquaters: 'USA',
    industry: 'PHARMACEUTICAL',
    spoc: 'LOUIS LITT',
    email: 'LITT@GSK.COM',
    mobile: '+147 567 5656',
    status: 'REGISTERED',
  },
];

export const inventoryTableData = [
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
  {
    assigned: 'LOUIS LITT',
    company: 'GSK',
    device: 'GATEWAY',
    id: 'GAT56453456',
    lastRetrieved: '10 min ago',
  },
];
